var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "120",
      height: "180",
      label: "服务器信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(_vm.serverList[scope.row.serverId]))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "220",
      height: "180",
      label: "角色信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("a", {
          staticStyle: {
            cursor: "pointer",
            color: "#409EFF"
          },
          on: {
            click: function click($event) {
              return _vm.goRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v("角色id：" + _vm._s(scope.row.roleId))]), _c("p", [_vm._v("角色名称：" + _vm._s(scope.row.roleName))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      height: "150",
      label: "货币变化时间",
      prop: "logTime"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "货币类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(_vm.coinList[scope.row.coinType]))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "180",
      label: "更改类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(scope.row.changeType == 1 ? "获得" : "消耗"))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "180",
      label: "更改原因"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(_vm.reasonList[scope.row.changeReason]))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "180",
      label: "更改数量",
      prop: "changeNum"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "180",
      label: "更改后数量",
      prop: "coinBalance"
    }
  })], 1)], _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };